function updateRechargeWidget() {
      //https://storefront.rechargepayments.com/client/docs/examples/shopify/snippet/
  
    console.log('start recharge widget')

    window.addEventListener('load', async function(){
      console.log('window loaded');
      
      await window.recharge.auth.loginShopifyAppProxy();
      
      const rechargeWidget = document.querySelector('#scarce-recharge-widget');

      if (rechargeWidget){
        const productId = rechargeWidget.dataset.productId;
        const productPrice = rechargeWidget.dataset.productPrice;
    
        const rechargePlans = window?.Recharge?.widgets[productId]?.product?.plans ?? false;
  
        console.log('recharge found: ' + rechargePlans)
        
        if (rechargePlans){
          for (const plan of rechargePlans){
            const priceSpan = document.querySelector('#recharge-price_' + plan.external_plan_id);
            
            if (plan.discount_type === 'percentage'){
              const discountPrice = ( productPrice - ( productPrice * (plan.discount_amount / 100) ) );
              priceSpan.innerText = `$${discountPrice.toFixed(2)}` ;
            }
          }
        }
      }
  })
}

function miscProductFunctions(){
  function initInfoBody() {
  console.log('start headers');
  let headers = document.querySelectorAll(".scarce-info-header");
  let bodies = document.querySelectorAll(".scarce-info-bodies");

  function clearHeaders() {
    headers.forEach((header) => {
      header.classList.remove("font-medium", "underline");
    });
  }

  headers.forEach((header) => {

    header.addEventListener("click", function() {
      const id = this.id;
      const bodyId = '#body__' + id;
      const body = document.querySelector(bodyId);

      clearHeaders();

      bodies.forEach((o_Body) => {
        o_Body.classList.add("hidden", "opacity-0");
      })

      this.classList.add("font-medium", "underline");
      body.classList.remove("hidden", "opacity-0");

    })
  });
};
initInfoBody();
}

function updatePriceOnSubcriptionChange(){
  console.log('start update price on sub change')
  const subscriptionApp = document.querySelector('.shopify_subscriptions_app_block');
  const priceField      = document.querySelector('#sticky-buy-buttons .price-p')
  if (subscriptionApp) {
    console.log('found');
    const options = subscriptionApp.querySelectorAll('.shopify_subscriptions_app_block_label');

    for (let option of options) {
      const radio = option.querySelector('input');
      option.addEventListener('click', (e) => {
         if (radio.checked) {
           priceField.innerText = radio.dataset.variantPrice
         } 
       })
    }
  }
}

function updatePriceChange(){
  
  // function updatePrice(){
  //     setTimeout(function(){
  //        document.querySelector(".price-p").innerHTML = status.innerHTML;
  //     }, 500)
  // }
  
  // document.addEventListener('DOMContentLoaded', function(){
  //     updatePrice();
  // })

  // const options = document.querySelectorAll('.product-form__input input[type="radio"]');
  // const status = document.querySelector("product-info [role='status']");  
  
  // for (let option of options) {
  //   option.addEventListener('click', function() {
  //       updatePrice();
  //   });
  // }

  // status.addEventListener('change', function(){
  //   setTimeout(function(){
  //     document.querySelector(".price-p").innerHTML = status.innerHTML;
  //   }, 500)
  // })
}

updateRechargeWidget();
miscProductFunctions();
//updatePriceChange();